<template>
  <div>
    <field-select-module
      title="작성자 정보"
      :visible-field-form="false"
      :board="this.board"
      :is-print="isPrint"
      v-model="form.stdInfo"
    />
    <div>
      <vs-row class="mt-6 mb-4">
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
          <h5><i class="dot"></i> 교육내용</h5>
        </vs-col>
      </vs-row>

      <div class="writeGridContainer">
        <div>
          <div>구분</div>
          <ml-input v-model="form.구분" :readonly="board.readonly" placeholder="입력필드" />
        </div>
        <div>
          <div>학교(기관)명</div>
          <field-selector v-model="form.학교명" :field-name="form.학교명_string" :readonly="board.readonly" @select="onChangeField"/>
        </div>
        <div>
          <div>성명</div>
          <ml-input v-model="form.성명" :readonly="board.readonly" placeholder="입력필드" />
        </div>
        <div>
          <div>이수여부</div>
          <vs-select v-model="form.이수여부" autocomplete :readonly="board.readonly" placeholder="입력필드">
            <vs-select-item v-for="item in ['이수', '미이수']" :key="item" :value="item" :text="item" />
          </vs-select>
        </div>
        <div>
          <div>이수방법</div>
          <vs-select v-model="form.이수방법" autocomplete :readonly="board.readonly" placeholder="입력필드">
            <vs-select-item v-for="item in ['집합(비대면실시간 포함)', '원격']" :key="item" :value="item" :text="item" />
          </vs-select>
        </div>
        <div>
          <div>이수시간</div>
          <ml-input v-model="form.이수시간" :readonly="board.readonly" placeholder="입력필드" />
        </div>
        <div>
          <div>수료일자</div>
          <date-selector class="w-full flex-1" v-model="form.수료일자" :readonly="board.readonly" />
        </div>
        <div>
          <div>수료기관</div>
          <ml-input v-model="form.수료기관" :readonly="board.readonly" placeholder="입력필드" />
        </div>
        <div>
          <div>미이수 사유</div>
          <ml-input v-model="form.미이수사유" :readonly="board.readonly" placeholder="입력필드" />
        </div>
      </div>

    </div>

    <file-upload-module id="fileList" class="w-full mt-4" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>
  </div>
</template>
<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule.vue";
import FileUploadModule from "@/views/modules/FileUploadModule.vue";
import DateSelector from "@/components/selector/DateSelector.vue";
import FieldSelector from "@/components/selector/FieldSelector.vue";

export default {
  components: {
    FieldSelector, DateSelector,
    FileUploadModule,
    FieldSelectModule
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      form: {
        stdInfo: {},
        fields: [], // 교육모니터링(684/page)에서 사용하는 필드, form.학교명과 동일하게 등록
        fileList: [],
        "연도": '',
        "구분": '',
        "학교명": '',
        "학교명_string": '',
        "급별": '',
        "성명": '',
        "이수여부": '',
        "이수방법": '집합',
        "이수시간": '',
        "수료일자": '',
        "수료기관": '',
        "미이수사유": '',
      }
    };
  },
  methods: {
    onChangeField (field) {
      this.form.fields = [field.id]
      this.form['학교명'] = field.id
      this.form['학교명_string'] = field.field_name
      this.form['급별'] = field.facility_category ? field.facility_category.cat3 : '-'
    },
  }
};
</script>

<style scoped lang="scss"></style>
